import React from "react";
import { Drawer, Space } from "antd";
import ColumnVisibilityPanel from "./ColumnVisibilityPanel";
import CustomButton from "../commonComponents/button";

const ColumnVisibilityDrawer = ({
  isVisible,
  onClose,
  columns,
  visibleColumns,
  defaultVisibleColumns,
  onColumnVisibilityChange,
  onApplyChanges,
  onResetDefaults,
}) => {
  return (
    <Drawer
      title="Show/Hide Columns"
      open={isVisible}
      onClose={onClose}
      width={400}
      footer={
        <div className="flex justify-between items-center">
          <Space>
            <CustomButton btnText="Apply" type="primary" handleClick={onApplyChanges} />
            <CustomButton btnText="Cancel" handleClick={onClose} />
          </Space>
          <CustomButton btnText="Reset to default" type="link" handleClick={onResetDefaults} />
        </div>
      }
    >
      <ColumnVisibilityPanel
        columns={columns}
        visibleColumns={visibleColumns}
        defaultVisibleColumns={defaultVisibleColumns}
        onColumnVisibilityChange={onColumnVisibilityChange}
      />
    </Drawer>
  );
};

export default ColumnVisibilityDrawer;
